import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search } from 'lucide-react';
import { Product } from '../../types/Product';
import { useProducts } from '../../context/ProductContext';
import { searchProducts } from '../../utils/search';
import { ProductSearchResult } from './ProductSearchResult';

interface ProductSearchProps {
  onProductSelect: (product: Product) => void;
}

export const ProductSearch: React.FC<ProductSearchProps> = ({
  onProductSelect
}) => {
  const { products } = useProducts();
  const [searchTerm, setSearchTerm] = useState('');
  const filteredProducts = searchProducts(products, searchTerm);
  const showResults = searchTerm.length >= 3;

  return (
    <div className="space-y-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
        <input
          type="text"
          placeholder="Buscar productos (mínimo 3 caracteres)..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border-2 border-orange-100 rounded-lg focus:border-orange-500 focus:ring-2 focus:ring-orange-200"
        />
      </div>

      {showResults && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-h-64 overflow-y-auto border rounded-lg divide-y"
        >
          {filteredProducts.length > 0 ? (
            filteredProducts.map(product => (
              <ProductSearchResult
                key={product.id}
                product={product}
                searchTerm={searchTerm}
                onSelect={() => onProductSelect(product)}
              />
            ))
          ) : (
            <div className="p-4 text-center text-gray-500">
              No se encontraron productos
            </div>
          )}
        </motion.div>
      )}
    </div>
  );
};